import React from 'react'
import PropTypes from 'prop-types'
import qs from 'qs'

import { useSelector, useDispatch } from 'react-redux'

import { withRouter } from '@piconetworks/router-adapter'
import WizardSlider from '@piconetworks/wizard-slider'

import { GetConfirmPaymentData } from 'apps/lib/CartHelper'
import orderTypes from 'apps/lib/CartHelper/orderTypes'

import Loader from 'common/modules/loader'
import Wizard from 'common/modules/wizard'
import PaymentV2 from 'common/modules/paymentv2'
import { getNavigateBackButton } from 'common/pkgs/WizardNavigation'

import FinalizePayment from './FinalizePayment'

const getWizardNameFromRoute = (location) => {
    if (!location || !location?.search) {
        return null
    }

    const searchString = location?.search.charAt(0) === '?' ? location?.search.substring(1) : location?.search
    const parseSearchString = qs.parse(searchString)
    const wizardName = parseSearchString?.id

    return wizardName
}

const InjectedFinalizePayment = ({ location, router }) => {
    const wizardName = getWizardNameFromRoute(location)

    const dispatch = useDispatch()

    const paymentMethodsData = useSelector(PaymentV2.selectors.getPaymentMethods)
    const defaultPaymentMethod = useSelector(PaymentV2.selectors.getDefaultPaymentMethod)

    const linkColor = useSelector(Loader.selectors.linkColor)
    const publisherName = useSelector(Loader.selectors.publisherName)
    const publisherId = useSelector(Loader.selectors.publisherId)

    const confirmPaymentData = useSelector((state) => GetConfirmPaymentData({
        state,
        wizardName,
        dispatch,
    }))

    const {
        type,
        postDataAction,
        Summary: OrderSummary,
    } = confirmPaymentData || {}

    const popupId = useSelector((state) => Wizard.selectors.thisWizardPopupId({ state, router }))
    const wizardTypes = useSelector((state) => Wizard.selectors.wizardTypes(state))

    const backButton = getNavigateBackButton({
        wizardTypes, popupId, router,
    })

    const { newsletters, customFields } = useSelector(
        (state) => Wizard.selectors.thisWizardPayload({
            state,
            router,
        }),
    )

    if (!type) {
        return null
    }

    const onBackButtonClick = !type.includes(orderTypes.gift.existing.convert.type)
        && backButton.onClick

    return (
        <FinalizePayment
            wizardPayload={{
                newsletters: newsletters?.newsletters,
                customFields,
            }}
            dispatch={dispatch}
            linkColor={linkColor}
            publisherName={publisherName}
            publisherId={publisherId}
            paymentMethodsData={paymentMethodsData}
            defaultPaymentMethod={defaultPaymentMethod}
            type={type}
            postDataAction={postDataAction}
            OrderSummary={OrderSummary}
            WizardSlider={WizardSlider}
            onBackButtonClick={onBackButtonClick}
            deleteCard={(idToDelete) => {
                const paymentMethodToDelete = paymentMethodsData.find(({ id }) => id === idToDelete)
                if (paymentMethodToDelete) {
                    dispatch(PaymentV2.creators.deletePayment({
                        payload: {
                            publisherId,
                            payload: {
                                source_id: paymentMethodToDelete.id,
                                account: paymentMethodToDelete.account,
                            },
                        },
                    }))
                }
            }}
        />
    )
}

export default withRouter(InjectedFinalizePayment)

InjectedFinalizePayment.propTypes = {
    location: PropTypes.string.isRequired,
    router: PropTypes.string.isRequired,
}
